
import styles from '../style.module.css';
import lang from "../../../lang/lang";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";

const FALLBACK_TEXT = {
    hy: [
        "Միացիր մեր թիմին և դարձիր ՎԻԷԼՎԻ մեծ ընտանիքի մաս։",
        "Մենք առաջարկում ենք աշխատանքային հնարավորություններ, մասնագիտական աճ և ժամանակակից միջավայր՝ այն մարդկանց համար, ովքեր սիրում են տեխնիկան և հաճախորդների սպասարկումը։",
    ],
    ru: [
        "Присоединяйтесь к нашей команде и станьте частью большой семьи VLV.",
        "Мы предлагаем карьерные возможности, профессиональный рост и современную среду для тех, кто любит технику и работу с клиентами.",
    ],
    en: [
        "Join our team and become part of the VLV family.",
        "We offer career opportunities, professional growth, and a modern workplace for people who love technology and customer care.",
    ],
};

function stripHtml(html = "") {
    return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
}

function Members({ image, title, text, link, linkText }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const navigate = useNavigate();
    const reduceMotion = useReducedMotion();

    const hasText = Boolean(stripHtml(text));
    const buttonLabel = stripHtml(linkText) || lang[currentLanguage]?.view_more;
    const target = link || "/job";
    const fallbackParagraphs = FALLBACK_TEXT[currentLanguage] || FALLBACK_TEXT.en;

    const fadeUp = reduceMotion
        ? {}
        : {
            initial: { opacity: 0, y: 24 },
            whileInView: { opacity: 1, y: 0 },
            viewport: { once: true, amount: 0.35 },
            transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
        };

    return (
        <div className={styles.members_section}>
            <motion.div
                className={styles.members_foto}
                {...(reduceMotion
                    ? {}
                    : {
                        initial: { opacity: 0, scale: 0.96, x: -18 },
                        whileInView: { opacity: 1, scale: 1, x: 0 },
                        viewport: { once: true, amount: 0.35 },
                        transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
                    })}
            >
                <img
                    src={image}
                    alt = { 'vlv team photo' }
                />
            </motion.div>
            <motion.div
                className={styles.members_text_link_content}
                {...fadeUp}
                transition={{ ...(fadeUp.transition || {}), delay: reduceMotion ? 0 : 0.12 }}
            >
                <h2> { title } </h2>
                {hasText ? (
                    <div
                        className={styles.members_text}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                ) : (
                    <div className={styles.members_text}>
                        {fallbackParagraphs.map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                        ))}
                    </div>
                )}
                <button
                    className={styles.members_link}
                    onClick={() => navigate(target)}
                >
                    { buttonLabel }
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                        <path d="M0.750037 0.75L5.25 5.25002L0.75 9.75002" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </motion.div>
        </div>
    )
}

export default Members
